const config = {
    API_BASE_URL: "https://orionlightingpvtltd.com/backend/public"
  };
  
  export default config;